import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { BaseClass } from 'src/app/shared/classes/base';
import { ReviewsInterface } from 'src/app/shared/interfaces/reviews.interface';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-ai-management-evaluation-user-list',
    templateUrl: './ai-management-evaluation-user-list.component.html',
    styleUrls: ['./ai-management-evaluation-user-list.component.scss'],
})
export class AiManagementEvaluationUserListComponent extends BaseClass implements OnInit {
    public _reviews: ReviewsInterface[] = [];
    
    @Input() set reviews(value: ReviewsInterface[]) {
        if (value) {
            this._reviews = value;
            let currentPage: number = 0;
            this.pages = value.map((review, index) => {
                if (index % 3 === 0) {
                    currentPage++;
                }
                return currentPage;
            });
        }
    }
    @Input() public usersCount: number;
    @Input() public colFullSize: boolean = false;
    @Input() public isExportMode: boolean = false;

    @Output() getReviewsForCalibrationGroup = new EventEmitter<CustomEvent>();
    @Output() openAiGeneralSummaryModal = new EventEmitter<ReviewsInterface>();

    public pages: number[] = [];

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,

    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() { }

    public getCurrentPage(index: number) {
        return this.pages[index];
    }

    public getReviewsForCalibrationGroupInternalEvent(event: CustomEvent) {
        this.getReviewsForCalibrationGroup.emit(event);
    }

    public async openAiGeneralSummaryModalInternalEvent(review: ReviewsInterface){
        this.openAiGeneralSummaryModal.emit(review);
    }

}
